import { createMuiTheme } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import createPalette from "@material-ui/core/styles/createPalette";
import createSpacing from "@material-ui/core/styles/createSpacing";
import createTypography from "@material-ui/core/styles/createTypography";
import grey from "@material-ui/core/es/colors/grey";

export const breakpoints = createBreakpoints({
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
});

const spacing = createSpacing();

const palette = createPalette({});

const typography = createTypography(palette, {
  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightBold: 700,
  htmlFontSize: 14,
  body1: {
    fontSize: 14,
    color: "#333333",
    lineHeight: 1.5,
  },
  body2: {
    fontSize: 18,
  },
  h5: {
    fontSize: 21,
    fontWeight: 300,
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: 14,
    padding: 0,
    color: grey[500],
    lineHeight: 1.5,
  },
  caption: {
    fontSize: 12,
    fontWeight: 500,
    color: grey[500],
  },
  button: {
    fontSize: 14,
  },
  helper: {
    fontSize: 12,
  },
  base: {
    fontSize: 16,
    lineHeight: 1.5,
  },
  label: {
    fontSize: 20,
    lineHeight: 1.2,
  },
  tooltip: {
    fontSize: 11,
  },
  tooltipIcon: {
    fontSize: 18,
  },
});

const AppTheme = createMuiTheme({
  breakpoints: {
    values: breakpoints,
  },
  typography,
  palette,
  overrides: {
    Mui: {
      disabled: {},
    },
    MuiAppBar: {
      root: {
        boxShadow: "none",
      },
    },
    MuiFormHelperText: {
      root: {
        ...typography.body1,
      },
    },
    MuiInputBase: {
      root: {
        "&.MuiInputBase-formControl": {
          ...typography.body2,
          margin: 0,
          marginTop: spacing() * 2,
          "&.Mui-disabled": {
            color: grey[700],
          },
          [breakpoints.down("md")]: {
            fontSize: 16,
          },
        },
      },
    },
    MuiMobileStepper: {
      positionStatic: {
        margin: "0 auto",
      },
      dot: {
        width: 12,
        height: 12,
        margin: "0 6px",
      },
    },
    MuiTableSortLabel: {
      root: {
        color: "primary",
        "&:hover": {
          color: "primary",
        },
        "&:focus": {
          color: "primary",
        },
      },
      active: {
        color: "primary",
      },
    },
    MuiTableRow: {
      root: {
        height: "36px",
      },
      head: {
        height: "48px",
      },
    },
    MuiTableCell: {
      root: {
        "&:last-child": {
          paddingRight: 2,
        },
      },
    },
    MuiListItem: {
      root: {
        paddingTop: spacing(1.5),
        paddingBottom: spacing(1.5),
        "&.Mui-selected": {
          borderRight: '3px solid',
          borderColor: "primary",
        },
      },
      gutters: {
        paddingLeft: spacing(3),
        paddingRight: spacing(3),
      },
    },
    MuiDialogActions: {
      root: {
        padding: spacing(2.5),
      },
    },
  },
  spacing,
  wbiComponent: {
    login: {
      width: 480,
      height: 600,
      formHeight: 368,
    },
    floatingNavigation: {
      totalWidth: 180,
      controlWidth: 40,
    },
    staticNavigation: {
      totalWidth: 140,
    },
    cyContainer: {
      basePadding: 20,
    },
    ctaController: {
      totalWidth: 60,
    },
    educationComponent: {
      height: 120,
    },
    welcomeComponent: {
      height: 120,
    },
    portfolioConfigBlock: {
      height: 80,
      moreSettingsControl: {
        width: 80,
      },
    },
    riskComponent: {
      riskSimChart: {
        height: 200,
      },
      riskSimCta: {
        height: 80,
      },
    },
  },
});
// To be used when combining media queries.
// Ex: [`@media only screen and ${theme.breakpoints.downNoMedia('md')}`]: { ... }
AppTheme.breakpoints.downNoMedia = (key) =>
  AppTheme.breakpoints.down(key).replace("@media ", "");
AppTheme.breakpoints.upNoMedia = (key) =>
  AppTheme.breakpoints.up(key).replace("@media ", "");

export { AppTheme };


const chartcolors = {
  C0: "#FFC658",
  C1: "#21AA72",
  C2: grey[700],
};

/**
 * Update chart color palette
 * @param {{C0: string, C1: string}} param0 
 */
export function updateChartColors({C0, C1}) {
  chartcolors.C0 = C0;
  chartcolors.C1 = C1;
}

export function* ChartColors() {
  yield chartcolors.C1;
  yield chartcolors.C2;

  while (true) {
    yield chartcolors.C0;
  }
}



// WEBPACK FOOTER //
// ./src/theme/index.js